import _ from 'lodash';
import moment from 'moment';

/**
 * Gộp danh sách thực phẩm theo sf_id, phân loại theo warehouse/non-warehouse.
 * @param {Array} items - marketMenuSchoolFoods
 * @param {boolean} useInWarehouse - true: lấy hàng kho, false: lấy hàng chợ
 * @returns {Array} grouped items
 */
export const groupBySchoolFood = (items, useInWarehouse) =>
    items
        ?.filter((o) => o.msf_useinwarehouse === useInWarehouse)
        .reduce((acc, item) => {
            const existing = acc.find((o) => o.id === item.sf_id);
            if (existing) {
                existing.items.push(item);
            } else {
                acc.push({
                    id: item.sf_id,
                    name: item.sf_name,
                    kg_id: item.kg_id,
                    price: item.msf_priceafter,
                    items: [item],
                });
            }
            return acc;
        }, []) ?? [];

/**
 * Gộp danh sách thực đơn theo ngày (m_datefounded).
 * @param {Array} menuList
 * @returns {Array<{ m_datefounded, ids, datas }>}
 */
export const groupMenusByDate = (menuList) =>
    _.chain(menuList)
        .groupBy('m_datefounded')
        .map((value, key) => ({
            m_datefounded: key,
            ids: value.map((o) => o.m_id),
            datas: value,
        }))
        .value();

/**
 * Lọc items theo kidGroup ids (dùng Set cho O(1) lookup).
 * @param {Set} kidGroupIdSet
 * @param {Array} items
 * @returns {Array}
 */
export const filterByKidGroup = (kidGroupIdSet, items) =>
    items?.filter((o) => kidGroupIdSet.has(o.kg_id)) ?? [];

/**
 * Tính danh sách ngày trong khoảng [dateFrom, dateTo] dưới dạng unix timestamp.
 */
export const getDaysArray = (year, month, dateFrom, dateTo) => {
    const date = new Date(year, month, dateFrom);
    const result = [];
    let i = date.getDate();
    while (i <= dateTo) {
        result.push(moment(date.setDate(i)).unix());
        i += 1;
    }
    return result;
};

/**
 * Chia khoảng thời gian thành các tuần (T2-T7).
 */
export const showWeeks = (_datefrom, _dateto) => {
    let startWeekFrom = _datefrom;
    let lastWeekFrom = moment.unix(_datefrom).weekday(5).endOf('day').unix();

    const out = [];

    if (lastWeekFrom > _dateto) {
        out.push({ start: startWeekFrom, end: _dateto });
        return out;
    }

    while (startWeekFrom <= _dateto) {
        out.push({ start: startWeekFrom, end: lastWeekFrom });

        const dayDateChange = moment.unix(lastWeekFrom).date() + 2;

        startWeekFrom = moment
            .unix(lastWeekFrom)
            .set('date', dayDateChange)
            .startOf('day')
            .unix();

        lastWeekFrom = moment
            .unix(startWeekFrom)
            .weekday(5)
            .endOf('day')
            .unix();

        if (lastWeekFrom >= _dateto) {
            lastWeekFrom = _dateto;
        }
    }

    return out;
};
